import { render, staticRenderFns } from "./UpdateSection.vue?vue&type=template&id=974752f2&scoped=true"
import script from "./UpdateSection.vue?vue&type=script&lang=js"
export * from "./UpdateSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974752f2",
  null
  
)

export default component.exports